import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API } from '@core/services/api.base';
import { PostEntity, PostQueryParams, PostsApiResponse } from 'src/app/models/post.model';

@Injectable({ providedIn: 'root' })
export class PostService extends API {
  getPosts(params: PostQueryParams = {}): Observable<PostsApiResponse> {
    const searchParams = new URLSearchParams();

    if (params.pageSize) {
      searchParams.append('pageSize', params.pageSize.toString());
    }
    if (params.lastDocumentId) {
      searchParams.append('lastDocumentId', params.lastDocumentId);
    }
    if (params.storeId) {
      searchParams.append('storeId', params.storeId);
    }
    if (params.topics) {
      searchParams.append('topics', params.topics);
    }
    if (params.searchTerm) {
      searchParams.append('searchTerm', params.searchTerm.trim());
    }

    const query = searchParams.toString();
    const endpoint = query ? `v1/posts?${query}` : 'v1/posts';
    return this.get<PostsApiResponse>(endpoint);
  }

  getPostById(postId: string): Observable<PostEntity> {
    return this.get<PostEntity>(`v1/posts/${postId}`);
  }
}
